import React from 'react'
import image0 from "../img/70179403-zwei-hände-halten-einen-blauen-planeten-erde-symbol-der-respekt-vor-der-natur-und-umwelt-flache-vekt.jpg"

const Slide0 = () => {
    return (
        <div className="">
            <div className="container container2">
                <div class="head"></div>
                <div className="text">
                    Wir Grüne haben uns festgelegt, für Deutschland die Vereinbarungen der Weltklimakonferenz 2015 in Paris zu erfüllen.
                    Mit einem Sofortprogramm wollen wir die klimaschädlichen Treibhausgase bis 2030 um 70% verringern. 
                </div>
                <div className="image image0">
                    <img src={image0} alt=""></img>
                </div>
                <div className="text">
                    Dann ist Schluss mit der Nutzung der Kohle, wird Strom ganz überwiegend aus Sonne und Wind erzeugt,
                    sind Gebäude energiesparend errichtet oder umgebaut. Auf den Straßen wird mit Elektroantrieb gefahren.
                    Zum Schutz von Klima und Artenvielfalt stellen wir die Landwirtschaft ökologisch und sozial um.
                </div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide0;